
export type TurnstileScriptLoader = () => Promise<Turnstile>;

export const loadCaptchaScript: TurnstileScriptLoader = () => {
  return new Promise((resolve) => {
    const existingScript = document.getElementById("turnstile-captcha");
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.id = "turnstile-captcha";
      script.defer = true;
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => {
        console.info("loaded script");
        return resolve(window.turnstile);
      };
    } else {
      return resolve(window.turnstile);
    }
  });
}

export type Turnstile = {
  render: (selector: string, options: TurnstileOptions) => void;
}

export type TurnstileOptions = {
  sitekey: string;
  theme: "light" | "dark";
  callback: (token: string) => void;
}

declare global {
  interface Window {
    turnstile: Turnstile;
  }
}